import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./WaterChapel.module.css";
import GameTemplate from "../games/GameTemplate";
import ShapeGame from "../games/ShapeGame";
import GameWrapper from "../GameWrapper";
const WaterChapel = () => {
  const navigate = useNavigate();

  const handleButtonClick = (path) => {
    navigate(path);
  };

  return (
    <GameWrapper backgroundImage="/WaterChapel.webp">
      <button
        onClick={() => handleButtonClick("/home")}
        className={`${styles.homeButton} ${styles.button}`}
      >
        Home
      </button>

      <button
        onClick={() => handleButtonClick("/map")}
        className={`${styles.mapButton} ${styles.button}`}
      >
        Map
      </button>

      <ShapeGame />
    </GameWrapper>
  );
};

export default WaterChapel;
